(function ($) {
  Drupal.behaviors.foundationFinder = {
    attach: function (context) {
      // Use custom filter logic over mix-it-up (animation is unnecessary)
      var $foundationFinder = $('.foundation-finder', context);
      var $filters = $('.product-filter', $foundationFinder);
      var $originalGrid = $('.js-product-grid', $foundationFinder);
      var $grid = $originalGrid.after('<div />').next();
      var $quiz = $('.foundation-finder__quiz', $foundationFinder);

      $('.js-foundation-finder-toggle', $foundationFinder).on('click keydown', function (e) {
        var keycode = site.getKeycode(e);

        if (keycode === 13 || keycode === 1) {
          !$(this).attr('aria-expanded') ? $(this).attr('aria-expanded', 'true') : $(this).attr('aria-expanded', 'false');
          $quiz.slideToggle(function () {
            $(this).css('overflow', '');
          });
        }
      });

      $filters.last().addClass('disabled');

      $filters.each(function (index) {
        var $filter = $(this);

        // var $triggers = $('.js-filter-trigger', $filter);
        $('.js-filter-trigger', $filter).on('click keydown', function (e) {
          e.preventDefault();
          var keycode = site.getKeycode(e);

          if (keycode === 13 || keycode === 1) {
            if ($filter.hasClass('disabled') || $(this).hasClass('active')) {
              return;
            }

            // Set the active class on the filters:
            $('.js-filter-trigger', $filter).removeClass('active');
            $(this).addClass('active');

            // Disable the second filter set if the first filter set is empty
            $filters.eq(1).removeClass('disabled');
            if (index === 1) {
              $foundationFinder.addClass('foundation-finder--filtered');
            }

            // If all filters are selected, filter the grid and reset the carousel
            var $activeTriggers = $('.js-filter-trigger.active', $filters);

            if ($activeTriggers.length >= $filters.length) {
              var filters = [];
              var filterString = '';

              $activeTriggers.each(function () {
                var filter = $(this).data('filter');

                if (filter) {
                  filters.push(filter);
                }
              });

              filterString = filters.join('');

              // Base the filtered carousel off the original carousel template.
              var $newCarousel = $originalGrid.clone();

              // Replace the old carousel with the new one:
              $grid.after($newCarousel);
              $grid.remove();
              $grid = $newCarousel;

              // Remove the items that shouldn't be there:
              $('.js-filter-item', $grid).each(function () {
                var $slide = $(this).closest('.product-grid__carousel__slide');
                var $item = $slide.length ? $slide : $(this);

                if (!filterString || !$(this).is(filterString)) {
                  $item.remove();
                }
              });

              $grid.show();
              var itemCount = $('.js-filter-item', $grid).length;

              $foundationFinder.toggleClass('foundation-finder--no-matches', !itemCount);
              Drupal.behaviors.productGrid.equalHeights($grid.parent());
              if (itemCount > 3) {
              // Initiate the newly rendered carousel:
                site.productCarousel.init($grid);
              }

              // grid does not always load correctly
              // adding in case we need to trigger secondary equalHeights
              $(document).trigger('foundation_finder_grid', $grid.parent());
            }
	 }
        });
      });
    }
  };
})(jQuery);
